import React from 'react';
import styled from 'styled-components';

const SectionWrapper = styled.section`
  background-color: #000000;
  padding: 5% 6%;
  box-sizing: border-box;

  @media (min-width: 500px) {
    padding: 5% 12% 5% 12%;
  }
`;

const Subtitle = styled.h3`
  text-align: center;
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.2em;
  color: #FFFF56;
  margin-bottom: 0px;

  @media (max-width: 500px) {
    font-size: 12px;
    line-height: 14px;
  }
`;

const Title = styled.h2`
  text-align: center;
  font-style: normal;
  font-weight: 700;
  font-size: 52px;
  line-height: 35px;
  letter-spacing: 0.05em;
  color: #FFFFFF;
  margin-bottom: 80px;

  @media (max-width: 500px) {
    font-size: 32px;
    line-height: 10px;
    margin-bottom: 40px;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 72px 36px 72px;

  @media (max-width: 500px) {
    flex-direction: column; /* 垂直排列 */
    padding: 0px ;
  }
`;

const TextWrapper = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 32px;
  color: #FFFFFF;
  align-items: flex-start;
  padding: 36px 0px 36px 48px;
  gap: 8px;
  margin-bottom: 16px;
  position: relative; 
  flex: 1; /* 確保文字區塊撐滿整個寬度 */

  @media (max-width: 500px) {
    max-width: 100%; 
    padding: 8px 8px;
    font-size: 14px;
    line-height: 24px;
  }
`;

const Image = styled.img`
  max-width: 50%;
  height: auto;

  @media (max-width: 500px) {
    order: -1; /* 调整顺序，使图像在文本上方 */
    max-width: 100%;
  }
`;

const ReadMoreButton = styled.button`
  background-color:#000000;
  color:#FFFFFF;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.05em;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 40px;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 100px;
  cursor: pointer;
  margin-right: auto;
  margin-top:48px;

  @media (max-width: 500px) {
    font-size: 14px;
    line-height: 24px;
    margin-top:24px;
    padding: 6px 20px;
    margin: 0 auto;

  }

  &:hover {
    background-color:#FFFFFF;
    color:#1f1f1f;
  }
`;

const DID = () => (
  <SectionWrapper>
    <Subtitle>Decentralized Identity</Subtitle>
    <Title>分散式身分DID</Title>
    <ContentWrapper>
      <Image src="/images/DID.png" alt="Image" />
      <TextWrapper>
        <p>國家發行的身份正在面對哪些挑戰？社會所面臨在政治及科技上的挑戰越來越多，線上群眾的真實面孔是人還是 AI？怎麼做才能真實反應人們的想法與意見？<br/><br/>科技巨頭提供的身份解方可能有什麼樣的問題？科技巨頭們掌握著我們的隱私、資料、及身份，在特殊情況下對於隱私、安全及意見形成都有很大的影嚮力，我們能夠如何應對？<br/><br/>身份作為構成社會的基礎原子，可以如何重新設計？我們能如何利用分散式科技，打開身份系統設計的更多可能，讓社會更加符合想像中的多元與涵融。</p>
        <a href="/did" style={{ textDecoration: 'none' }}><ReadMoreButton>閱讀更多</ReadMoreButton></a>
      </TextWrapper>
    </ContentWrapper>
  </SectionWrapper>
);

export default DID;
